module.exports = __webpack_public_path__ + "static/img/focused-path-location-marker.5846c13.svg";